/* eslint-disable */
import { useState, useEffect } from "react";

//import gateway and url helper
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";
import { assetImages } from "constants";

const UserDetailsPopup = ({
  selectedUserId = null,
  setSelectedUserId = () => {},
}) => {
  const token = localStorage.getItem("token");
  const [userDetails, setUserDetails] = useState({});
  const [userAssocitedCompanies, setUserAssocitedCompanies] = useState([]);
  const [usersDaysAvailibility, setUsersDaysAvailibility] = useState([]);
  const [loading, setLoading] = useState(false);

  const getUserDetails = async () => {
    try {
      setLoading(true);
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USER_DETAILS +
        `/${selectedUserId}` +
        `?token=${token}`;

      // console.log("requestUrl in user details popup", requestUrl);

      const response = await getData(requestUrl);

      // console.log("response in user details popup", response);

      if (response.status && response.data) {
        setUserDetails(response.data);
        const requestMemberUrl =
          url.API_BASE_URL +
          url.API_GET_COMPANY_LIST_BY_MEMBER +
          `?userid=${selectedUserId}`;

        // console.log("requestMemberUrl in user details popup", requestMemberUrl);

        const companyResponse = await getData(requestMemberUrl);
        // console.log("companyResponse in user details popup", companyResponse);

        if (companyResponse.status && companyResponse.data) {
          setUserAssocitedCompanies(companyResponse.data);
        }

        const requestAvailibilityUrl =
          url.API_BASE_URL +
          url.API_GET_ALL_SCHEDULE_AVAILIBILITY +
          `?token=${token}&filteruserids=${selectedUserId}`;

        // console.log(
        //   "requestAvailibilityUrl in user details popup",
        //   requestAvailibilityUrl
        // );

        const availibilityResponse = await getData(requestAvailibilityUrl);
        // console.log(
        //   "availibilityResponse in user details popup",
        //   availibilityResponse
        // );

        if (availibilityResponse.status && availibilityResponse.data) {
          setUsersDaysAvailibility(availibilityResponse.data);
        }
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setLoading(false);
    }
  };

  const closePopupHandler = () => {
    setSelectedUserId(null);
  };

  useEffect(() => {
    if (selectedUserId) {
      getUserDetails();
    }
  }, [selectedUserId]);

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0 shadow-lg"
      tabIndex="-1"
      id="userDetailsPopup"
      aria-labelledby="userDetailsPopup"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              medical_information
            </span>
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="offcanvasLabelDetailsLabel"
            >
              Doctor Details
            </h3>
            <p className="text-white fs-sm mb-0">View doctor information</p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={closePopupHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        {loading ? (
          <div className="text-center text-muted py-5">
            <span className="spinner-border text-primary mb-3"></span>
            <div>Loading user details...</div>
          </div>
        ) : userDetails && userDetails._id ? (
          <div className="container-fluid">
            {/* Profile Header Card */}
            <div className="card mb-4 border-0 shadow-sm">
              <div className="card-body text-center">
                <img
                  src={
                    userDetails.photoimage?.path
                      ? url.SERVER_URL + userDetails.photoimage.path
                      : assetImages.defaultUser
                  }
                  alt="Doctor Profile"
                  className="rounded-circle mb-3 border border-gray-300"
                  style={{ width: 120, height: 120, objectFit: "cover" }}
                />
                <h4 className="fw-bold mb-1">
                  {userDetails.name} {userDetails.surname}
                </h4>
                <p className="text-muted mb-2">{userDetails.position}</p>
                <div className="d-flex justify-content-center gap-2 mb-3">
                  <span className="badge bg-danger-subtle text-primary px-3 py-2">
                    {userDetails.role?.name}
                  </span>
                </div>
                {userDetails.about && (
                  <div
                    className="text-muted small"
                    dangerouslySetInnerHTML={{ __html: userDetails.about }}
                  />
                )}
              </div>
            </div>

            {/* Contact Information Card */}
            <div className="card mb-4 border-0 shadow-sm">
              <div className="card-header bg-light border-0">
                <h6 className="mb-0 fw-bold">
                  <span className="material-symbols-outlined align-middle me-2">
                    contact_mail
                  </span>
                  Contact Information
                </h6>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-12">
                    <div className="d-flex align-items-center">
                      <span className="material-symbols-outlined text-primary me-2">
                        mail
                      </span>
                      <div>
                        <small className="text-muted d-block">Email</small>
                        <span>{userDetails.email}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="d-flex align-items-center">
                      <span className="material-symbols-outlined text-primary me-2">
                        call
                      </span>
                      <div>
                        <small className="text-muted d-block">Phone</small>
                        <span>{userDetails.phone}</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="d-flex align-items-start">
                      <span className="material-symbols-outlined text-primary me-2">
                        location_on
                      </span>
                      <div>
                        <small className="text-muted d-block">Location</small>
                        <span>
                          {userDetails.address}
                          {userDetails.city && `, ${userDetails.city}`}
                          {userDetails.state && `, ${userDetails.state}`}
                          {userDetails.country && `, ${userDetails.country}`}
                          {userDetails.zipcode && ` - ${userDetails.zipcode}`}
                        </span>
                      </div>
                    </div>
                  </div>
                  {userDetails.website && (
                    <div className="col-12">
                      <div className="d-flex align-items-center">
                        <span className="material-symbols-outlined text-primary me-2">
                          language
                        </span>
                        <div>
                          <small className="text-muted d-block">Website</small>
                          <a
                            href={`https://${userDetails.website}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none"
                          >
                            {userDetails.website}
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Clinic Information Card */}
            {userDetails.company && (
              <div className="card mb-4 border-0 shadow-sm">
                <div className="card-header bg-light border-0">
                  <h6 className="mb-0 fw-bold">
                    <span className="material-symbols-outlined align-middle me-2">
                      local_hospital
                    </span>
                    Associated Clinics
                  </h6>
                </div>
                <div className="card-body">
                  <div className="d-flex align-items-center">
                    {userDetails.companylogo?.path && (
                      <img
                        src={url.SERVER_URL + userDetails.companylogo.path}
                        alt="Clinic Logo"
                        className="rounded me-3"
                        style={{ width: 60, height: 60, objectFit: "cover" }}
                      />
                    )}
                    <div>
                      <h6 className="mb-0 fw-bold">{userDetails.company}</h6>
                      <small className="text-muted">Healthcare Facility</small>
                    </div>
                  </div>
                </div>

                {userAssocitedCompanies.map((clinic, index) => {
                  const matchingDays = usersDaysAvailibility.filter((day) =>
                    day.timeavailibilitylist.some(
                      (time) => time.companyid === clinic._id
                    )
                  );

                  return (
                    <div
                      className="card-body border-top position-relative overflow-hidden"
                      key={index}
                    >
                      {/* Decorative accent line */}
                      {/* <div
                        className="position-absolute start-0 top-0 bottom-0 bg-primary"
                        style={{
                          width: "4px",
                          opacity: 0.7,
                          transition: "opacity 0.3s ease",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.opacity = "1")
                        }
                      ></div> */}

                      <div className="d-flex gap-3 align-items-start ps-2">
                        {/* Clinic Logo */}
                        <div className="position-relative">
                          <img
                            className="rounded-3 border border-2 shadow-sm"
                            style={{
                              width: 70,
                              height: 70,
                              objectFit: "cover",
                              transition: "transform 0.3s ease",
                            }}
                            src={
                              !clinic.companylogo || clinic.companylogo === ""
                                ? assetImages.defaultUser
                                : url.SERVER_URL + clinic.companylogo
                            }
                            alt={clinic.name}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.transform = "scale(1.05)")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.transform = "scale(1)")
                            }
                          />
                        </div>

                        {/* Clinic Details */}
                        <div className="flex-grow-1">
                          <h6 className="mb-2 fw-bold text-dark d-flex align-items-center gap-2">
                            {clinic.name}
                            {/* <span
                              className="badge bg-danger-subtle text-primary fs-xs px-2 py-1"
                              style={{ fontSize: "0.7rem" }}
                            >
                              {clinic.companytypename}
                            </span> */}
                          </h6>

                          {/* Location */}
                          <div className="mb-2 d-flex align-items-start">
                            <span
                              className="material-symbols-outlined text-primary me-2"
                              style={{ fontSize: "18px" }}
                            >
                              location_on
                            </span>
                            <small className="text-muted">
                              {clinic.location}
                            </small>
                          </div>

                          {/* Services */}
                          {clinic.servicestring && (
                            <div className="mb-2 d-flex align-items-start">
                              <span
                                className="material-symbols-outlined text-primary me-2"
                                style={{ fontSize: "18px" }}
                              >
                                medical_services
                              </span>
                              <small className="text-muted">
                                <strong className="text-dark">Services:</strong>{" "}
                                {clinic.servicestring}
                              </small>
                            </div>
                          )}

                          {/* Visit Times */}
                          {matchingDays.length > 0 && (
                            <div className="mt-3">
                              <div className="d-flex align-items-center mb-2">
                                <span
                                  className="material-symbols-outlined text-primary me-2"
                                  style={{ fontSize: "18px" }}
                                >
                                  schedule
                                </span>
                                <small className="fw-bold text-dark">
                                  Visiting Hours
                                </small>
                              </div>
                              <div className="d-flex flex-wrap gap-2 ms-4">
                                {matchingDays.map((day, dayIndex) => {
                                  const time = day.timeavailibilitylist.find(
                                    (t) => t.companyid === clinic._id
                                  );
                                  return (
                                    <div
                                      key={dayIndex}
                                      className="badge bg-light text-dark border px-3 py-2 d-flex align-items-center gap-2"
                                      style={{
                                        fontSize: "0.75rem",
                                        fontWeight: "500",
                                        borderRadius: "8px",
                                      }}
                                    >
                                      <span className="fw-bold text-primary">
                                        {day.dayname}
                                      </span>
                                      <span className="text-muted">|</span>
                                      <span className="text-success">
                                        {time.starttime}
                                      </span>
                                      <span>-</span>
                                      <span className="text-danger">
                                        {time.endtime}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Professional Details */}
            <div className="row mb-4">
              {/* Services Offered */}
              {userDetails.services && userDetails.services.length > 0 && (
                <div className="col-12 mb-3">
                  <div className="card border-0 shadow-sm h-100">
                    <div className="card-header bg-light border-0">
                      <h6 className="mb-0 fw-bold">
                        <span className="material-symbols-outlined align-middle me-2">
                          medical_services
                        </span>
                        Services Offered
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="d-flex flex-wrap gap-2">
                        {userDetails.services.map((service) => (
                          <span
                            key={service._id}
                            className="badge bg-danger-subtle text-primary px-3 py-2"
                          >
                            {service.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Clinical Expertise */}
              {userDetails.skills && userDetails.skills.length > 0 && (
                <div className="col-12 mb-3">
                  <div className="card border-0 shadow-sm h-100">
                    <div className="card-header bg-light border-0">
                      <h6 className="mb-0 fw-bold">
                        <span className="material-symbols-outlined align-middle me-2">
                          workspace_premium
                        </span>
                        Clinical Expertise
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="d-flex flex-wrap gap-2">
                        {userDetails.skills.map((skill) => (
                          <span
                            key={skill._id}
                            className="badge bg-danger-subtle text-primary px-3 py-2"
                          >
                            {skill.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Areas of Interest */}
              {userDetails.interests && userDetails.interests.length > 0 && (
                <div className="col-12">
                  <div className="card border-0 shadow-sm h-100">
                    <div className="card-header bg-light border-0">
                      <h6 className="mb-0 fw-bold">
                        <span className="material-symbols-outlined align-middle me-2">
                          favorite
                        </span>
                        Medical Specializations
                      </h6>
                    </div>
                    <div className="card-body">
                      <div className="d-flex flex-wrap gap-2">
                        {userDetails.interests.map((interest) => (
                          <span
                            key={interest._id}
                            className="badge bg-danger-subtle text-danger px-3 py-2"
                          >
                            {interest.name}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>

            {/* Additional Information */}
            <div className="card border-0 shadow-sm">
              <div className="card-header bg-light border-0">
                <h6 className="mb-0 fw-bold">
                  <span className="material-symbols-outlined align-middle me-2">
                    info
                  </span>
                  Additional Information
                </h6>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-6">
                    <small className="text-muted d-block">Language</small>
                    <span className="fw-medium">
                      {userDetails.userlanguage || userDetails.language}
                    </span>
                  </div>
                  <div className="col-6">
                    <small className="text-muted d-block">Cost Per Hour</small>
                    <span className="fw-medium">
                      ${userDetails.costperhour}
                    </span>
                  </div>
                  {userDetails.ecosystemid?.name && (
                    <div className="col-6">
                      <small className="text-muted d-block">Ecosystem</small>
                      <span className="fw-medium">
                        {userDetails.ecosystemid.name}
                      </span>
                    </div>
                  )}
                  <div className="col-6">
                    <small className="text-muted d-block">Status</small>
                    <span
                      className={`badge ${
                        userDetails.status === "1"
                          ? "bg-success"
                          : "bg-secondary"
                      }`}
                    >
                      {userDetails.status === "1" ? "Active" : "Inactive"}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center text-muted py-5">
            <div>No user details available.</div>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserDetailsPopup;
